<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlert" variant="warning" dismissible>
    {{ alertMsg }}
  </b-alert>

  <b-modal v-model="showModal" ref="delete" id="delete" title="Conferma cancellazioe" @ok="handleDelete" @cancel="handleCancel">
    <h3>Sei sicuro di voler cancellare la riga?</h3>
  </b-modal>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Formule"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <span class='label'>
                Formula
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-input v-model="selectedFormula.formula" class=""></b-form-input>
            </b-col>
          </b-row>            

          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelFormula">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertFormula">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateFormula">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Formule"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <table class="">
                <thead>
                  <tr>
                    <th style="width: 0%;"></th>
                    <th style="width: 95%;">Formula</th>
                    <th style="width: 5%;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="formula in paginatedFormulas" :key="formula.id" class="row-selection">
                    <td @click="editRow(formula)"  style="visibility: hidden;">{{ formula.id }}</td>
                    <td @click="editRow(formula)" >{{ formula.formula }}</td>
                    <td @click="editRow(formula)">
                      <i v-if="formula.active" class="fas fa-check" style="color: green;"></i>
                    </td>
                    <td><i class="fas fa-trash" @click="deleteRecord(formula.id)" style="pointer: cursor !important;"></i></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
                @change="onPageChange"
                class="my-3"
              ></b-pagination>            
            </b-col>
            <b-col cols="2">
              <span>Pagina {{ currentPage }} di {{ totalPages }} pagine</span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>


</div>